import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var Icon = function (_a) {
    var icon = _a.icon, size = _a.size, title = _a.title;
    return _jsx(FontAwesomeIcon, { "aria-hidden": true, title: title, icon: icon, size: size });
};
export default Icon;
